
import { Component, Vue } from 'vue-property-decorator';
import { answerConfirm, confirmState } from '@/content/confirm';

/** The confirmation dialog of the content editor (see askConfirm), instead of the browser's own pop-up. */
@Component
export default class ConfirmDialog extends Vue {
  state = confirmState;

  answer(value: boolean): void {
    answerConfirm(value);
  }

  /** Clicking outside or pressing Escape closes it: that is "Annuleren". */
  onInput(open: boolean): void {
    if (!open) answerConfirm(false);
  }
}
